/**
 * Client-side mirror of server workspace file attachment policy (pre-check before upload).
 */

const BLOCKED_EXTENSIONS = new Set(
  [
    "exe",
    "dll",
    "bat",
    "cmd",
    "com",
    "scr",
    "pif",
    "msi",
    "msp",
    "msc",
    "hta",
    "vbs",
    "vbe",
    "wsf",
    "wsh",
    "ps1",
    "psm1",
    "psd1",
    "psc1",
    "cpl",
    "reg",
    "lnk",
    "gadget",
    "app",
    "apk",
    "sh",
    "bash",
    "zsh",
    "fish",
  ].map((s) => s.toLowerCase()),
);

const BLOCKED_MIME_EXACT = new Set(
  [
    "application/x-msdownload",
    "application/x-msdos-program",
    "application/x-executable",
    "application/x-msi",
    "application/x-ms-shortcut",
    "application/x-sh",
    "application/x-shellscript",
    "text/javascript",
    "application/javascript",
    "application/x-javascript",
    "application/java-archive",
  ].map((s) => s.toLowerCase()),
);

const BLOCKED_MIME_PREFIXES = ["application/x-ms", "application/vnd.microsoft.portable-executable"];

export function extensionFromFilename(filename: string): string {
  const base = filename.replace(/^.*[/\\]/, "").trim();
  const dot = base.lastIndexOf(".");
  if (dot < 0 || dot === base.length - 1) return "";
  return base.slice(dot + 1).toLowerCase();
}

export function sanitizeTopicAttachmentFilename(raw: string): string {
  let s = raw.replace(/^.*[/\\]/, "").replace(/\0/g, "").trim();
  if (s === "." || s === "..") s = "file";
  s = s.replace(/[\x00-\x1f\x7f]/g, "");
  if (s.length > 200) s = s.slice(0, 200);
  return s || "file";
}

export function isTopicFileAttachmentAllowed(mime: string, filename: string): boolean {
  const ext = extensionFromFilename(filename);
  if (ext && BLOCKED_EXTENSIONS.has(ext)) return false;

  const m = mime.trim().toLowerCase();
  if (!m) return !(ext && BLOCKED_EXTENSIONS.has(ext));
  if (BLOCKED_MIME_EXACT.has(m)) return false;
  for (const p of BLOCKED_MIME_PREFIXES) {
    if (m.startsWith(p)) return false;
  }
  if (m.startsWith("text/javascript") || m.startsWith("application/javascript")) return false;
  return true;
}
